import type { UploadVariantDto } from '@shared/all/domains/uploads';

import { getS3ObjectURL } from './s3';

// Branded "image unavailable" placeholder served for uploads whose source is gone.
export const SOURCE_MISSING_PLACEHOLDER = '/images/image-unavailable.svg';

type ViewableUpload =
  | { display: UploadVariantDto; sourceMissing?: boolean }
  | null
  | undefined;

// Resolve the render URL — VIEW for images (watermarked when factiii), RAW for
// non-images. Signed URL when set (private posts), else public CDN URL. Dead
// hot-links (SOURCE_MISSING) resolve to the branded placeholder, so a plain
// next/image renders it server-side with no client error-handling.
export const getDisplaySrc = (upload: ViewableUpload): string => {
  if (upload?.sourceMissing) return SOURCE_MISSING_PLACEHOLDER;
  if (!upload?.display) return '';
  if (upload.display.url && upload.display.url.length > 0)
    return upload.display.url;
  if (upload.display.key) return getS3ObjectURL(upload.display.key);
  return '';
};

export const getUploadSrc = getDisplaySrc;
